export default __webpack_public_path__ + "static/media/MusicHeader.8027cf08.jpg";